import React from 'react';
import PropTypes from 'prop-types';
import SecurityQuestionsAndAnswersV2 from '../../../components/composite/FormSets/SecurityQuestionsAndAnswersV2/SecurityQuestionsAndAnswersV2';

const SecurityQuestionsAndAnswersControlSet = ({
  questions,
  answers,
  setQuestions,
  setAnswers,
  changeHandlers,
}) => (
  <SecurityQuestionsAndAnswersV2
    questions={questions}
    answers={answers}
    setQuestions={setQuestions}
    setAnswers={setAnswers}
    questionLabels={['Security Question 1', 'Security Question 2', 'Security Question 3']}
    answerLabels={['Answer 1', 'Answer 2', 'Answer 3']}
    changeHandlers={changeHandlers}
  />
);

SecurityQuestionsAndAnswersControlSet.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      state: PropTypes.number,
    }),
  ).isRequired,
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      state: PropTypes.number,
    }),
  ).isRequired,
  setQuestions: PropTypes.func.isRequired,
  setAnswers: PropTypes.func.isRequired,
  changeHandlers: PropTypes.shape({
    questions: PropTypes.func,
    answers: PropTypes.func,
    questionOptionsPromise: PropTypes.shape({
      promise: PropTypes.instanceOf(Promise),
      resolveCb: PropTypes.func,
      rejectCb: PropTypes.func,
    }).isRequired,
  }).isRequired,
};

export default SecurityQuestionsAndAnswersControlSet;
